import React, { useState } from 'react';
import { Avatar, Input, Textarea, Button } from '@nextui-org/react';
import { FaTimes } from 'react-icons/fa';
import { postProjectsUpdate, postProjectsUploadImage } from '../../../services/projects';
import Notiflix from 'notiflix';

const EditPopupComponent = ({ projectsData, closePopup, onUpdate, show, projectSlug }) => {
  const [isOpen, setIsOpen] = useState(true)
  const [formData, setFormData] = useState({
    pname: projectsData?.pname || '',
    pdesc: projectsData?.pdesc || '',
    pbudget: projectsData?.pbudget || '',
    penddate: projectsData?.penddate || '',
    pfirm: projectsData?.pfirm || ''
  });
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const handleClose = () => {
    closePopup(false)
  }

  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      closePopup(false)
    }
  }

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleImageSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Dosya tipini kontrol et
      if (!file.type.startsWith('image/')) {
        Notiflix.Notify.failure('Lütfen geçerli bir resim dosyası seçin!');
        return;
      }
      
      // Dosya boyutunu kontrol et (5MB limit)
      if (file.size > 5 * 1024 * 1024) {
        Notiflix.Notify.failure('Dosya boyutu 5MB\'dan küçük olmalıdır!');
        return;
      }
      
      setSelectedImage(file);
      
      // Preview oluştur
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageUpload = async () => {
    if (!selectedImage || !projectSlug) return;
    
    try {
      setImageLoading(true);
      
      await postProjectsUploadImage(projectSlug, selectedImage);
      
      Notiflix.Notify.success('Proje fotoğrafı başarıyla yüklendi!');
      
      // Parent component'e güncelleme bildir
      if (onUpdate) {
        onUpdate();
      }
      
      // State'i temizle
      setSelectedImage(null);
      setPreviewImage(null);
      
    } catch (error) {
      console.error('Fotoğraf yükleme hatası:', error);
      Notiflix.Notify.failure('Fotoğraf yüklenirken bir hata oluştu!');
    } finally {
      setImageLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      
      
      // Tarihi timestamp'e çevir
      const updateData = {
        ...formData,
        penddate: formData.penddate ? Math.floor(new Date(formData.penddate).getTime() / 1000) : null,
        pcustomer: 1 // Sabit değer
      };

      await postProjectsUpdate(projectSlug, updateData);
      
      Notiflix.Notify.success('Proje başarıyla güncellendi!');
      
      // Parent component'e güncelleme bildir
      if (onUpdate) {
        onUpdate();
      }
      
      closePopup(false);
      
    } catch (error) {
      console.error('Proje güncelleme hatası:', error);
      Notiflix.Notify.failure('Proje güncellenirken bir hata oluştu!');
    } finally {
      setLoading(false);
    }
  };

  
  return (
    <>
      {show && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={handleBackgroundClick}>
          <div className="bg-white dark:bg-dark-200 w-[900px] max-h-[90vh] rounded-lg z-50 overflow-y-auto shadow-2xl">
            {/* Header */}
            <div className="sticky top-0 bg-white dark:bg-dark-200 border-b border-gray-200 dark:border-dark-300 p-6 rounded-t-lg">
              <div className="flex items-center justify-between">
                <h1 className="text-xl font-semibold text-gray-900 dark:text-white">Projeyi Düzenle</h1>
                <button 
                  onClick={handleClose}
                  className="p-2 hover:bg-gray-100 dark:hover:bg-dark-300 rounded-full transition-colors"
                >
                  <FaTimes className="text-gray-500 dark:text-gray-400" size={20} />
                </button>
              </div>
            </div>

            <div className="p-6 space-y-6">

              {/* Proje Görseli */}
              <div className="space-y-3">
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Proje Görseli</label>
                <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg p-6 text-center hover:border-blue-400 dark:hover:border-blue-500 transition-colors">
                  {previewImage ? (
                    <div className="space-y-4">
                      <div className="flex items-center justify-center">
                        <img 
                          src={previewImage} 
                          alt="Yeni görsel önizleme" 
                          className="w-24 h-24 object-cover rounded-lg"
                        />
                      </div>
                      <div className="space-y-2">
                        <p className="text-sm text-gray-600 dark:text-gray-400">Yeni görsel seçildi</p>
                        <div className="flex justify-center space-x-2">
                          <Button
                            size="sm"
                            color="primary"
                            onClick={handleImageUpload}
                            isLoading={imageLoading}
                            disabled={imageLoading}
                            className="bg-blue-600 hover:bg-blue-700 text-white"
                          >
                            {imageLoading ? 'Yükleniyor...' : 'Yükle'}
                          </Button>
                          <Button
                            size="sm"
                            variant="ghost"
                            onClick={() => {
                              setSelectedImage(null);
                              setPreviewImage(null);
                            }}
                            className="text-gray-600 dark:text-gray-400"
                          >
                            İptal
                          </Button>
                        </div>
                      </div>
                    </div>
                  ) : projectsData.pimg !== null ? (
                    <div className="flex items-center justify-center space-x-4">
                      <Avatar
                        src={projectsData.pimg}
                        className="w-16 h-16"
                      />
                      <div className="text-left">
                        <p className="text-sm text-gray-600 dark:text-gray-400">Mevcut görsel</p>
                        <label className="text-blue-600 dark:text-blue-400 text-sm hover:underline cursor-pointer">
                          Değiştir
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageSelect}
                            className="hidden"
                          />
                        </label>
                      </div>
                    </div>
                  ) : (
                    <div className="space-y-2">
                      <div className="w-16 h-16 mx-auto bg-gray-100 dark:bg-gray-700 rounded-lg flex items-center justify-center">
                        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <label className="text-sm text-gray-500 dark:text-gray-400 cursor-pointer hover:text-blue-600 dark:hover:text-blue-400">
                        Görsel yüklemek için tıklayın
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleImageSelect}
                          className="hidden"
                        />
                      </label>
                    </div>
                  )}
                </div>
                <p className="text-xs text-gray-500 dark:text-gray-400">Maksimum dosya boyutu: 5MB</p>
              </div>

              {/* Proje Bilgileri */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Proje Adı</label>
                  <Input 
                    type="text" 
                    value={formData.pname}
                    className="w-full"
                    variant="bordered"
                    isDisabled
                    classNames={{
                      input: "text-gray-500 dark:text-gray-400",
                      inputWrapper: "bg-gray-100 dark:bg-gray-700 border-gray-300 dark:border-gray-600"
                    }}
                  />
                  <p className="text-xs text-gray-500 dark:text-gray-400">Proje adını değiştiremezsiniz</p>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Proje Firması</label>
                  <Input 
                    type="text" 
                    value={formData.pfirm}
                    onChange={(e) => handleInputChange('pfirm', e.target.value)}
                    className="w-full"
                    variant="bordered"
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Tahmini Bitiş Tarihi</label>
                  <Input 
                    type="date" 
                    value={formData.penddate}
                    onChange={(e) => handleInputChange('penddate', e.target.value)}
                    className="w-full"
                    variant="bordered"
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Proje Bütçesi</label>
                  <Input 
                    type="text" 
                    value={formData.pbudget}
                    onChange={(e) => handleInputChange('pbudget', e.target.value)}
                    placeholder="₺ 0.00"
                    className="w-full"
                    variant="bordered"
                  />
                </div>
              </div>

              {/* Açıklama */}
              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Proje Açıklaması</label>
                <Textarea
                  value={formData.pdesc}
                  onChange={(e) => handleInputChange('pdesc', e.target.value)}
                  placeholder="Proje hakkında detaylı bilgi..."
                  className="w-full"
                  variant="bordered"
                  minRows={3}
                />
              </div>
              {/* Proje Aksiyonları */}
              <div className="space-y-4">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Proje Aksiyonları</h3>
                
                {/* Tamamlandı */}
                <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 bg-blue-100 dark:bg-blue-800 rounded-full flex items-center justify-center">
                      <svg className="w-4 h-4 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h4 className="font-medium text-blue-900 dark:text-blue-100">Projeyi Tamamlandı Olarak İşaretle</h4>
                      <p className="text-sm text-blue-700 dark:text-blue-300 mt-1">
                        Projeyi tamamlandı olarak işaretlediğiniz zaman hiçbir işlemi kullanamayacaksınız.
                      </p>
                      <Button 
                        className="mt-3 bg-blue-600 hover:bg-blue-700 text-white"
                        size="sm"
                      >
                        Tamamlandı Olarak İşaretle
                      </Button>
                    </div>
                  </div>
                </div>

                {/* Deaktif */}
                <div className="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg p-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 bg-orange-100 dark:bg-orange-800 rounded-full flex items-center justify-center">
                      <svg className="w-4 h-4 text-orange-600 dark:text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h4 className="font-medium text-orange-900 dark:text-orange-100">Projeyi Deaktif Et</h4>
                      <p className="text-sm text-orange-700 dark:text-orange-300 mt-1">
                        Projeyi deaktif ettiğiniz zaman hiçbir işlemi kullanamayacaksınız.
                      </p>
                      <Button 
                        className="mt-3 bg-orange-600 hover:bg-orange-700 text-white"
                        size="sm"
                      >
                        Deaktif Et
                      </Button>
                    </div>
                  </div>
                </div>

                {/* Sil */}
                <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 bg-red-100 dark:bg-red-800 rounded-full flex items-center justify-center">
                      <svg className="w-4 h-4 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h4 className="font-medium text-red-900 dark:text-red-100">Projeyi Kalıcı Olarak Sil</h4>
                      <p className="text-sm text-red-700 dark:text-red-300 mt-1">
                        Proje silme işlemini onaylamanız halinde, tüm içerikler kalıcı olarak silinmektedir.
                      </p>
                      <Button 
                        className="mt-3 bg-red-600 hover:bg-red-700 text-white"
                        size="sm"
                      >
                        Kalıcı Olarak Sil
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="sticky bottom-0 bg-white dark:bg-dark-200 border-t border-gray-200 dark:border-dark-300 p-6 rounded-b-lg">
              <div className="flex justify-end space-x-3">
                <Button 
                  onClick={handleClose}
                  variant="ghost"
                  className="text-gray-600 dark:text-gray-400"
                >
                  İptal
                </Button>
                <Button 
                  color="primary"
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                  onClick={handleSave}
                  isLoading={loading}
                  disabled={loading}
                >
                  {loading ? 'Kaydediliyor...' : 'Değişiklikleri Kaydet'}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default EditPopupComponent
